import { render, staticRenderFns } from "./chat-message-redirect.vue?vue&type=template&id=028e971d&scoped=true"
import script from "./chat-message-redirect.vue?vue&type=script&lang=js"
export * from "./chat-message-redirect.vue?vue&type=script&lang=js"
import style0 from "./chat-message-redirect.vue?vue&type=style&index=0&id=028e971d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028e971d",
  null
  
)

export default component.exports